import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import SuggestionForm from './SuggestionForm';

const useStyles = makeStyles(() => ({
  integrationPaper: {
    padding: '10px',
    position: 'relative',
    minHeight: '250px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const SuggestionIntegration = () => {
  const classes = useStyles();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const closeModal = () => setModalIsOpen(false);
  return (
    <>
      {modalIsOpen && <SuggestionForm closeModal={closeModal} />}
      <Paper
        variant="outlined"
        elevation={3}
        className={`${classes.integrationPaper} ${classes.flexCenter}`}
        onClick={() => setModalIsOpen(true)}
      >
        <Typography variant="h6" gutterBottom>
          Suggest a new integration
        </Typography>
      </Paper>
    </>
  );
};

export default SuggestionIntegration;
